/* eslint-disable @typescript-eslint/no-explicit-any */
// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';

const WalletGiftCardsSection = dynamic(() =>
  import('./WalletGiftCardsSection').then(mod => mod.WalletGiftCardsSection)
);

export const WalletGiftCardsSectionConfig = {
  emptyLabel: 'walletgiftcardssection',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/walletgiftcardssection`,
};

export const WalletGiftCardsSectionEditable = (props: any) => (
  <EditableComponent config={WalletGiftCardsSectionConfig} {...props}>
    <WalletGiftCardsSection {...props} />
  </EditableComponent>
);

export type {
  WalletGiftCardsSectionProps,
  WalletGiftCardsSectionModel,
  WalletGiftCardsSectionRenditions,
} from './WalletGiftCardsSection.types';
